import FGTSList from '@/views/fgts/FGTSList.vue';
import FGTSConsultRedesign from '@/views/fgts/FGTSConsultRedesign.vue';

const name = 'fgts';
const path = '/fgts';

export default [
  // routes
  {
    name: `${name}-proposal`,
    path: `${path}/propostas`,
    component: FGTSList,
  },
  {
    name: `${name}-consult`,
    path: `${path}/consultar`,
    component: FGTSConsultRedesign,
  },
  {
    name: `${name}-reserve`,
    path: `${path}/reservar`,
    component: () => import('@/views/ReservationList.vue'),
  },
  {
    name: `${name}-mass-consult`,
    path: `${path}/consultar/lote`,
    component: () => import('@/views/fgts/FGTSMassConsult.vue'),
  },
  {
    name: `${name}-new`,
    path: `${path}/novo`,
    component: () => import('@/views/fgts/FGTSNewProposal.vue'),
  },
  {
    name: `${name}-mass-consult-historic`,
    path: `${path}/consultar/lote/historico`,
    component: () => import('@/views/fgts/FGTSMassConsultHistoric.vue'),
  },

  // redirects (legacy)
  {
    path: `${path}/consulta-por-lote`,
    redirect: `${path}/consultar/lote`,
  },
  {
    path: `${path}/consultar/novo`,
    redirect: `${path}/consultar`,
  },
];
